<script setup lang="ts">
import { computed } from "vue";
import { useStore } from "vuex";
import { addSizeToDataLayer } from "@/functions/analytics";
import DimensionInput from "@/components/UI/DimensionInput.vue";
import ShapeInputFieldsWrapper from "@/components/UI/ShapeInputFieldsWrapper.vue";
import {Props} from "@/components/ShapeType.vue";
import ValidationMessage from '@/components/UI/ValidationMessage.vue';

const store = useStore();
const { isCutout, action, prefix } = defineProps<Props>();
const dimensions = computed(() => store.getters.getMeasurements( 'flat-oval', isCutout ) );
const dimensionLabel = computed(() => store.getters.dimensionLabel);
const dimensionMaxLabel = computed(() => store.getters.getMaxLabelForDimension);
const isDimensionValid = computed(() => store.getters.isShapeValid( isCutout ) );
const message = computed(() => store.getters.getInstructionsForDimension);

const width = computed({
	get: () => dimensions.value.width,
	set: (value: string|number) => {
		store.dispatch(action, {
			dimension: "width",
			value: value,
		});
	},
});

const radius = computed({
	get: () => dimensions.value.radius,
	set: (value: string|number) => {
		store.dispatch(action, {
			dimension: "radius",
			value: value,
		});
	},
});

</script>
<template>
	<shape-input-fields-wrapper>
		<dimension-input
			inputRef="flat-oval-width"
			:id="`${prefix}measurements-flat-oval-width`"
			:name="`${prefix}measurements[dimensions][width]`"
			unit="cm"
			:label="dimensionLabel('width')"
			:instructions="isCutout ? '' : dimensionMaxLabel('width')"
			:invalid="!isDimensionValid(`${prefix}flat-oval-width`)"
			:onBlur="() => addSizeToDataLayer('width', +width, 'flat-oval')"
			v-model="width"
		/>

		<dimension-input
			inputRef="flat-oval-radius"
			:id="`${prefix}measurements-flat-oval-radius`"
			:name="`${prefix}measurements[dimensions][radius]`"
			unit="cm"
			:label="dimensionLabel('radius')"
			:instructions="isCutout ? '' : dimensionMaxLabel('radius')"
			:invalid="!isDimensionValid(`${prefix}flat-oval-radius`)"
			:onBlur="() => addSizeToDataLayer('radius', +radius, 'flat-oval')"
			v-model="radius"
		/>

		<div class="full" v-if="message('width', 'radius', isCutout)">
			<validation-message type="notice">
				{{ message('width', 'radius', isCutout) }}
			</validation-message>
		</div>
		<div class="full" v-if="message('radius', 'width', isCutout)">
			<validation-message type="notice">
				{{ message('radius', 'width', isCutout) }}
			</validation-message>
		</div>
	</shape-input-fields-wrapper>
</template>
<style scoped lang="scss">
.full {
	grid-column: 1 / -1;
}
</style>
